// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"851d365d","666":"6c7a204e"}[chunkId] + ".chunk.js";
};